import { differenceInCalendarDays, differenceInMinutes, isToday, isYesterday } from 'date-fns';
import { useTranslation } from 'react-i18next';

export const useFormatConversationTimestamp = (timestamp: Date) => {
  const { t } = useTranslation(['translationReactComponents']);
  const compareDate = new Date();

  if (Math.abs(differenceInMinutes(compareDate, timestamp)) < 1) {
    return t('Now');
  }

  if (isToday(timestamp)) {
    return t('dateFormats.time', { date: timestamp });
  }

  if (isYesterday(timestamp)) {
    return t('Yesterday');
  }

  const daysAgo = differenceInCalendarDays(compareDate, timestamp);

  if (daysAgo >= 0 && daysAgo < 7) {
    return t('dateFormats.dayShort', { date: timestamp });
  }

  return t('dateFormats.shortMonthDayYear', { date: timestamp });
};
